/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Reference vocabularies: Ancient Greek and Latin Dependency Treebank, Bamberger Wortschatz, PROIEL treebank, Vischer Wortkunde, VIVA textbook
 */
export type VocabularyMC = 'agldt' | 'bws' | 'proiel' | 'vischer' | 'viva';

export const VocabularyMC = {
    Agldt: 'agldt' as VocabularyMC,
    Bws: 'bws' as VocabularyMC,
    Proiel: 'proiel' as VocabularyMC,
    Vischer: 'vischer' as VocabularyMC,
    Viva: 'viva' as VocabularyMC
};

